import React from "react";

import Grid from "@material-ui/core/Grid";

import { CollapseHeader, FormCollapse } from "components/Form";
import {
  CheckBox,
  Input,
  SelectField,
  withNamespace,
} from "components/Form/FormikControls";
import { DescriptiveOption } from "components/SearchableSelector";

import {
  BusinessLabelSendModeOptions,
  FinanceSubModalSection,
} from "constants/settings";

import { SectionToggleState, useSectionHelper } from "hooks";

export const XeroLabelSyncSettings = ({
  sectionHelper,
  namespace: ns,
}: {
  sectionHelper: SectionToggleState;
  namespace: string;
}) => {
  const { isOpen, onToggle } = useSectionHelper(
    sectionHelper,
    FinanceSubModalSection.XERO_LABEL_SYNC,
  );

  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={<CollapseHeader title="Xero Label Send" />}
    >
      <Grid container item spacing={2} xs={12}>
        <Grid item xs={12}>
          <Input
            label="Xero Label Prefix"
            name={withNamespace(ns, "xeroLabelPrefix")}
            tooltip="Prefix applied to Xero contact group names, for both AgriNous-defined groups and Business Labels. Leave blank for no prefix."
          />
        </Grid>
        <Grid item xs={12}>
          <CheckBox
            label="Send AgriNous Defined Labels"
            name={withNamespace(ns, "sendAgrinousLabels")}
            tooltip="Send AgriNous-defined groups (e.g. Has Consigned, Top Buyer Cattle) to Xero as contact groups."
          />
        </Grid>
        <Grid item xs={12}>
          <SelectField
            label="Send Business Labels"
            name={withNamespace(ns, "sendBusinessLabels")}
            options={BusinessLabelSendModeOptions}
            tooltip="Controls which Business Labels are sent to Xero as contact groups."
            components={{ Option: DescriptiveOption }}
          />
        </Grid>
      </Grid>
    </FormCollapse>
  );
};
